export const unitySetAudio = () => {
  (window as any)["setAudio"] = async () => {
    const hyperbeamAudioCtx = new (window["AudioContext"] ||
      (window as any)["webkitAudioContext"])();
    await hyperbeamAudioCtx.audioWorklet.addModule("unity/UnityAudioHook.js");
    (window as any)["hyperbeamAudioCtx"] = hyperbeamAudioCtx;
  };
};
